import React from 'react';

export const Header = ({ onSearch }) => {
  const handleSearch = (event) => {
    onSearch(event.target.value);
  };

  return (
    <header className="w-full h-[54px] z-10 text-white flex justify-center bg-[#CC3333] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] fixed">
      <div className="w-full flex items-center lg:w-[1120px] gap-8 justify-between">
        <a href="/" className="flex items-center">
          <img
            src="/images/logo-sol.png"
            className="w-[70px] py-2 px-2"
            alt="Logo Carne de Sol do Edu"
          />
          <h1 className="font-bold text-2xl md:text-4xl text-[#FAE374]">
            <span className="hidden md:inline">Carne de Sol do Edu | </span> Cardápio
          </h1>
        </a>
        <div className="border-2 rounded-md mr-2 p-1 flex items-center">
            <input id="search" type="search" className="w-full bg-transparent px-1" placeholder="Pesquisar..." onChange={handleSearch} />
            <button>
                <img src="/images/search.png" alt="search" />
            </button>
        </div>
      </div>
    </header>
  );
};
